
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import OverlayStore from '@/modules/common/layout/store/overlay.store'

@Component
export default class Overlay extends Vue {
  constructor(
    private readonly store: OverlayStore
  ) {
    super()
  }

  get overlay() {
    return this.store.overlay
  }

  closeOverlay() {
    this.store.overlay = false
  }

  beforeDestroy() {
    this.closeOverlay()
  }
}
